<template>
  <div class="info-bar">
    <div class="users-counter" :class="{ 'counter-highlight': isChanging }">
      <div class="status-indicator"></div>
      <span class="counter-text">
        <transition name="number-change" mode="out-in">
          <span :key="totalClients">{{ totalClients }}</span>
        </transition>
        active
      </span>
      <span class="counter-label">{{ usersLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBar',
  props: {
    totalClients: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      previousCount: 0,
      isChanging: false,
    };
  },
  computed: {
    usersLabel() {
      return this.totalClients === 1 ? 'user' : 'users';
    },
  },
  watch: {
    totalClients(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isChanging = true;
        this.previousCount = oldVal;

        setTimeout(() => {
          this.isChanging = false;
        }, 300);
      }
    },
  },
  methods: {},
};
</script>

<style scoped>
.info-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.users-counter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(102, 126, 234, 0.1);
  padding: 0.75rem 1.25rem;
  border-radius: 50px;
  border: 1px solid rgba(102, 126, 234, 0.2);
  transition: all 0.3s ease;
  /* Предотвращаем layout shift */
  min-width: 120px;
  white-space: nowrap;
}

.users-counter:hover {
  background: rgba(102, 126, 234, 0.15);
  /* Убираем transform для стабильности */
}

.counter-highlight {
  background: rgba(102, 126, 234, 0.2) !important;
  /* Убираем transform и анимации */
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.status-indicator {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  position: relative;
  /* Убираем анимацию для стабильности */
}

.status-indicator::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: inherit;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  /* Убираем анимацию кольца */
}

/* Убираем keyframes анимаций */

/* Убираем анимацию изменения числа */
.number-change-enter-active,
.number-change-leave-active {
  transition: none; /* Убираем переходы */
}

.number-change-enter-from {
  opacity: 1; /* Сразу показываем */
  transform: none;
}

.number-change-leave-to {
  opacity: 1; /* Сразу показываем */
  transform: none;
}

.counter-text {
  font-weight: 600;
  color: #667eea;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  /* Фиксированная ширина для числа чтобы избежать дерганья */
  position: relative;
}

.counter-text span {
  display: inline-block;
  min-width: 1.5em;
  text-align: center;
}

.counter-label {
  color: #6c757d;
  font-size: 0.9rem;
}

@media (max-width: 480px) {
  .users-counter {
    padding: 0.5rem 1rem;
  }

  .counter-text {
    font-size: 1rem;
  }

  .counter-label {
    font-size: 0.8rem;
  }
}
</style>
